var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonePreviewHoriz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 42.9",
    style: {
      enableBackground: "new 0 0 53 42.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADADAD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-Copy",
    className: "st0",
    d: "M10.6,9c-1.7,0-3.2,1.4-3.2,3.1v18.8c0,1.7,1.4,3.1,3.2,3.1h31.7c1.7,0,3.2-1.4,3.2-3.1V12.1 c0-1.7-1.4-3.1-3.2-3.1H10.6z M10.5,24.1v-5.3c0-0.5,0.2-0.9,0.5-0.9s0.5,0.4,0.5,0.9v5.3c0,0.5-0.2,0.9-0.5,0.9 S10.5,24.6,10.5,24.1z M42.5,21.5c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5S42.5,20.6,42.5,21.5z M38.5,12v19 h-22V12H38.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePreviewHoriz);
export default __webpack_public_path__ + "static/media/PhonePreviewHoriz.09580960.svg";
export { ForwardRef as ReactComponent };